export const getYandexMetricsId = (path?: string) => {
  if (typeof window !== 'undefined' && path) {
    if (path.includes('/wl/')) {
      return window.yaCounter87750877 ? window.yaCounter87750877.getClientID() : '';
    }
    return window.yaCounter159737 ? window.yaCounter159737.getClientID() : '';
  }
  return '';
};
